import { render, staticRenderFns } from "./SecondaryContact.vue?vue&type=template&id=5ea16b3a&"
import script from "./SecondaryContact.vue?vue&type=script&lang=js&"
export * from "./SecondaryContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports